import { Header } from '@hwm/ui-lib';
import { makeStyles, Theme } from '@material-ui/core';
import { MenuOpen } from '@material-ui/icons';
import { useSidebar } from '@shared/hooks';
import React from 'react';
import { MENU_ICON } from '../Layout/AppLayout';

const useStyles = makeStyles((theme: Theme) => ({
  label: {
    height: 44,
    minHeight: 44,
    margin: theme.spacing(0, 0, 1),
  },
  wrappedLabel: {
    [theme.breakpoints.down('xs')]: {
      height: 76,
      minHeight: 76,
      alignItems: 'flex-start',
      flexDirection: 'column',
      maxWidth: '100%',
    },
  },
  buttonsWrapper: {
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'space-between',
      width: '100%',
      height: 32,
      '& button': {
        height: 32,
        marginLeft: 0,
        marginRight: theme.spacing(1),
      },
    },
  },
  btn: {
    width: MENU_ICON,
    minWidth: MENU_ICON,
    minHeight: MENU_ICON,
    height: MENU_ICON,
    [theme.breakpoints.down('xs')]: {
      width: MENU_ICON - 4,
      minWidth: MENU_ICON - 4,
      minHeight: MENU_ICON - 4,
      height: MENU_ICON - 4,
    },
    cursor: 'pointer',
    marginRight: theme.spacing(3),
    transition: 'transform 0.3s',
    transform: ({ show }: { show: boolean }) => (show ? 'rotate(180deg)' : 'rotate(0)'),
  },
}));

interface CustomHeaderProps {
  title: string;
  buttons?: JSX.Element[];
  showSidebarIcon?: boolean;
  wrapButtons?: boolean;
  hideDivider?: boolean;
}

export const CustomHeader: React.FC<CustomHeaderProps> = ({
  title,
  buttons,
  showSidebarIcon = false,
  wrapButtons = false,
  hideDivider = false,
}) => {
  const {
    sidebar: { state },
    handleSidebarState,
  } = useSidebar();

  const classes = useStyles({ show: state });

  return (
    <Header
      icon={showSidebarIcon ? <MenuOpen className={classes.btn} onClick={() => handleSidebarState(false)} /> : null}
      title={title}
      buttons={
        buttons ? (
          <div className="flex items-center justify-end w-full">
            {buttons.map((btn, i) => (
              <React.Fragment key={i}>{btn}</React.Fragment>
            ))}
          </div>
        ) : null
      }
      labelContainerClasses={`${classes.label} ${wrapButtons ? classes.wrappedLabel : ''}`}
      buttonsContainerClasses={classes.buttonsWrapper}
      truncateTitle
      showDivider={!hideDivider}
    />
  );
};
